import Loadable from 'react-loadable';

import LoadableLoadingPage from './LoadableLoadingPage';

// eslint-disable-next-line import/no-default-export
export default Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "gradSchools/GradProgramPageContainer" */
      './GradProgramPageContainer'
    ),
  loading: LoadableLoadingPage,
});
